import { request, success, failure, CLIENTS } from "./utilities";
import {
  deleteClientApi,
  addNewClientApi,
  editClientApi,
  getClientListApi,
} from "../api";

export function getAllClients(data) {
  return (dispatch) => {
    dispatch(request(CLIENTS.GET_CLIENT_REQUEST));
    getClientListApi(data).then(
      (response) => {
        if (response.data.status === 200) {
          dispatch(success(CLIENTS.GET_CLIENT_SUCCESS, response.data.data));
        } else {
          dispatch(failure(CLIENTS.GET_CLIENT_FAILURE, response.data.message));
        }
      },
      (error) => {
        dispatch(
          failure(
            CLIENTS.GET_CLIENT_FAILURE,
            error &&
              error.response &&
              error.response.data &&
              error.response.data.title
              ? error.response.data.title
              : error.message
          )
        );
      }
    );
  };
}

export function addClient(clientData, moveToNext, Notification) {
  return (dispatch) => {
    dispatch(request(CLIENTS.ADD_CLIENT_REQUEST));
    addNewClientApi(clientData).then(
      (response) => {
        if (response.data.status === 200) {
          dispatch(success(CLIENTS.ADD_CLIENT_SUCCESS, response.data.data));
          if (moveToNext) {
            moveToNext();
          }
          if (Notification) {
            Notification(response.data.message, "success");
          }
        } else {
          dispatch(failure(CLIENTS.ADD_CLIENT_FAILURE, response.data.message));
          if (Notification) {
            Notification(response.data.message, "error");
          }
        }
      },
      (error) => {
        dispatch(
          failure(
            CLIENTS.ADD_CLIENT_FAILURE,
            error &&
              error.response &&
              error.response.data &&
              error.response.data.title
              ? error.response.data.title
              : error.message
          )
        );
      }
    );
  };
}

export function editClient(clientData, moveToNext, Notification) {
  return (dispatch) => {
    dispatch(request(CLIENTS.EDIT_CLIENT_REQUEST));

    editClientApi(clientData).then(
      (response) => {
        if (
          response.data.status === 200 ||
          response.data.message === "Success"
        ) {
          dispatch(success(CLIENTS.EDIT_CLIENT_SUCCESS, response.data.data));
          if (moveToNext) {
            moveToNext();
          }
          if (Notification) {
            Notification(response.data.message, "success");
          }
        } else {
          dispatch(failure(CLIENTS.EDIT_CLIENT_FAILURE, response.data.message));
          if (Notification) {
            Notification(response.data.message, "error");
          }
        }
      },
      (error) => {
        dispatch(
          failure(
            CLIENTS.EDIT_CLIENT_FAILURE,
            error &&
              error.response &&
              error.response.data &&
              error.response.data.title
              ? error.response.data.title
              : error.message
          )
        );
      }
    );
  };
}

export function removeClient({ clientId, Notification }) {
  return (dispatch) => {
    dispatch(request(CLIENTS.REMOVE_CLIENT_REQUEST));
    deleteClientApi(clientId).then(
      (response) => {
        if (
          response.data.status === 200 ||
          response.data.message === "Success"
        ) {
          dispatch(success(CLIENTS.REMOVE_CLIENT_SUCCESS, clientId));
          if (Notification) {
            Notification(response.data.message, "success");
          }
        } else {
          dispatch(
            failure(CLIENTS.REMOVE_CLIENT_FAILURE, response.data.message)
          );
          if (Notification) {
            Notification(response.data.message, "error");
          }
        }
      },
      (error) => {
        dispatch(
          failure(
            CLIENTS.REMOVE_CLIENT_FAILURE,
            error &&
              error.response &&
              error.response.data &&
              error.response.data.title
              ? error.response.data.title
              : error.message
          )
        );
      }
    );
  };
}
